import { motion } from "framer-motion";
import { ClipboardList, MessageCircle, ArrowUpRight } from "lucide-react";
import ChapterHeading from "@/components/ChapterHeading";

const WHATSAPP_URL =
  "https://wa.me/528331474951?text=" +
  encodeURIComponent("Hola María Guadalupe, quiero levantar un reporte de servicios públicos en mi colonia.");

export default function Propuestas({ config }) {
  const formUrl =
    config?.google_form_url ||
    "https://docs.google.com/forms/d/e/1FAIpQLSdlp3iKEXk88XA4YKgHFaLmLmEyj6aYJJyqquDbWirzvs2JdQ/viewform?embedded=true";
  return (
    <section id="propuestas" data-testid="propuestas-section" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <ChapterHeading
          num="06 · Participación Ciudadana"
          title="Tu voz cuenta: propuestas, sugerencias y reportes"
          desc="Este gobierno escucha. Comparte una propuesta o sugerencia para tu colonia, o levanta un reporte de servicios públicos por WhatsApp con María Guadalupe."
        />
        <div className="grid md:grid-cols-2 gap-6 md:gap-8 items-stretch">
          <motion.div
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
            data-testid="propuestas-card"
            className="rounded-3xl border border-border bg-arena-light grain relative overflow-hidden flex flex-col items-center justify-center text-center px-8 py-14 md:py-16 shadow-[0_24px_50px_-24px_rgba(90,82,74,0.45)]"
          >
            <span className="p-4 rounded-2xl bg-guinda/10 text-guinda mb-6">
              <ClipboardList className="w-8 h-8" aria-hidden="true" />
            </span>
            <p className="font-mono text-[11px] tracking-[0.3em] uppercase text-guinda">Propuestas y sugerencias</p>
            <h3 className="mt-3 font-serif text-2xl sm:text-3xl text-gris-charcoal text-balance">
              Imagina y propón para tu colonia
            </h3>
            <p className="mt-3 text-gris max-w-md leading-relaxed">
              Una obra, un programa, una mejora o una sugerencia: cuéntanos tu idea en el formulario oficial.
              Solo te tomará un par de minutos.
            </p>
            <a
              href={formUrl.replace("?embedded=true", "")}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="propuestas-participa-button"
              className="mt-8 inline-flex items-center gap-2 rounded-full bg-guinda hover:bg-guinda-dark text-white text-lg font-medium px-10 py-4 shadow-[0_16px_36px_-14px_rgba(192,60,84,0.7)] transition-all duration-200 hover:-translate-y-0.5"
            >
              Participa
              <ArrowUpRight className="w-5 h-5" aria-hidden="true" />
            </a>
            <p className="mt-6 font-mono text-xs tracking-[0.25em] uppercase text-gris/70">
              Se abre en una pestaña nueva · Google Forms
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: 0.12, ease: [0.16, 1, 0.3, 1] }}
            data-testid="whatsapp-card"
            className="rounded-3xl border border-gris-charcoal bg-gris-charcoal grain relative overflow-hidden flex flex-col items-center justify-center text-center px-8 py-14 md:py-16 shadow-[0_24px_50px_-24px_rgba(45,40,37,0.6)]"
          >
            <span className="p-4 rounded-2xl bg-verde/20 text-verde mb-6">
              <MessageCircle className="w-8 h-8" aria-hidden="true" />
            </span>
            <p className="font-mono text-[11px] tracking-[0.3em] uppercase text-arena">Reportes de servicios públicos</p>
            <h3 className="mt-3 font-serif text-2xl sm:text-3xl text-white text-balance">
              Reporta con María Guadalupe
            </h3>
            <p className="mt-3 text-arena/90 max-w-md leading-relaxed">
              ¿Falla de alumbrado, bache, fuga o basura acumulada? Levanta tu reporte por WhatsApp con
              María Guadalupe, el sistema de atención ciudadana del municipio.
            </p>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="whatsapp-reporte-button"
              className="mt-8 inline-flex items-center gap-2 rounded-full bg-verde hover:bg-[#166A43] text-white text-lg font-medium px-10 py-4 shadow-[0_16px_36px_-14px_rgba(30,126,80,0.8)] transition-all duration-200 hover:-translate-y-0.5"
            >
              Enviar reporte por WhatsApp
              <ArrowUpRight className="w-5 h-5" aria-hidden="true" />
            </a>
            <p className="mt-6 font-mono text-xs tracking-[0.25em] uppercase text-arena/60">
              +52 833 147 4951 · Se abre WhatsApp
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
